import * as uuid from 'uuid';

export class AftercareAddOn {
    id;
    name;
    price;
    required;
    maxAmount;
    active;
    new;

    constructor(obj) {
        this.id = obj && obj.id || uuid();
        this.name = obj && obj.name || '';
        this.price = obj && obj.price || '';
        this.required = obj && obj.required || false;
        this.maxAmount = obj && obj.maxAmount || 10;
        this.active = obj && obj.active || true;
        this.new = obj && obj.id ? false : true;
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/aftercare-form/aftercare-add-on.js